export default __webpack_public_path__ + "static/allency-support-areas-programming-abd1049abf0fdf8d8a488fb6238e5f8c.svg";